module.exports = __webpack_public_path__ + "static/media/tokiwa10-8.bd4d3dc3.jpg";